import BaseCommand from "@/models/api/commands/BaseCommand";

export class CopyCostDocumentKsefNumberToAllBookingItemsCommand extends BaseCommand {
  CommandName = "CopyCostDocumentKsefNumberToAllBookingItems";
  Command: {
    Value: string;
  };
  constructor(sessionId: string, operationId: string, value: string) {
    super(sessionId, operationId);
    this.Command = { Value: value };
  }
}
